// extracted by mini-css-extract-plugin
export default {"SubscriptionInfo":"UserDetails_SubscriptionInfo__06wZ2"};